import { getHonorariumMovementTypeDescription } from '../../enums/EHonorariumMovementType';

interface MovementTypeTagProps {
    movementType?: number | null;
    /** Texto del tipo, cuando ya viene traducido del backend en vez del código. */
    label?: string | null;
    /** Lo que el tipo no dice (NC/ND, prefactura, causa de la corrección); sin dato no se muestra nada debajo. */
    detail?: string | null;
}

/** Tipo de movimiento de honorario (Orden / Ajuste / Anulación) con su detalle debajo, si tiene. */
export default function MovementTypeTag({ movementType, label, detail }: MovementTypeTagProps) {
    const typeLabel = label ?? (movementType != null ? getHonorariumMovementTypeDescription(movementType) : null);
    return (
        <div className="flex flex-column" style={{ gap: 'var(--space-1)' }}>
            {typeLabel
                ? <span className="md-tag md-tag-mut" style={{ alignSelf: 'flex-start' }}>{typeLabel}</span>
                : <span>—</span>}
            {detail && <span style={{ fontSize: 12, color: 'var(--text-2)' }}>{detail}</span>}
        </div>
    );
}
